<div class="row">
  <div class="col-md-12 col-lg-4 col-xxxl-4">
    <!-- <nb-card>
      <nb-card-header>Common Datepicker</nb-card-header> -->
      <!-- <nb-card-body> -->
        <input nbInput
               placeholder="Form Picker"
               name="meta_date_birthdate"
               [(ngModel)]="dateValue" 
               [nbDatepicker]="formpicker"  (change)="onDateChange($event)" >
               <nb-datepicker
               #formpicker
              
               (dateChange)="onDateChange($event)"
               [min]="min"
               [max]="max"
               >
             </nb-datepicker>
      <!-- </nb-card-body>
    </nb-card> -->
  </div>
</div>
